'use client';

import { Pagination } from 'antd';
import { useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

type PaginationWrapperProps = {
  total: number;
  pageSize: number;
  current: number;
};

export function PaginationWrapper({ total, pageSize, current }: PaginationWrapperProps) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleOnPageChange = useCallback(
    (page: number) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set('page', page.toString());
      router.push(`?${params.toString()}`);
    },
    [router, searchParams],
  );

  return (
    <Pagination
      onChange={handleOnPageChange}
      pageSize={pageSize}
      total={total}
      current={current}
      showSizeChanger={false}
      style={{ marginBottom: 32 }}
    />
  );
}
